<template>
  <div style="background-color:#EFEFEF">
    <v-container>
      <v-row
        align="left"
        justify="left"
      >
        <v-col cols="2" class="mr-8"></v-col>
        <v-col
          cols="7"
        >
          <h1 class="display-2 mb-4 mt-15 font-weight-bold text-left" style="color:#425C80">
            SINGLES MINISTRIES
          </h1>
          <h3 class="font-weight-regular mb-3" style="color:#425C80">
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore.            </h3>
          <v-btn
            large
            rounded
            elevation="4"
            color="#425C80"
            class="px-8 font-weight-regular"
          >
            <div style="color:white">JOIN</div>
          </v-btn>
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'SeniorsChoir'
}
</script>
